import { createContext, useContext, useState } from "react";
import { IUserMineInfo } from "../services/user/user.service";

const MineInfoContext = createContext<{
  mineInfo: IUserMineInfo | null;
  setMineInfo: (mineInfo: IUserMineInfo | null) => void;
  checkPermission: (permission: string) => boolean;
}>({
  mineInfo: null,
  setMineInfo: () => {},
  checkPermission: () => false,
});

export const MineInfoContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [mineInfo, setMineInfo] = useState<IUserMineInfo | null>(null);

  const checkPermission = (permission: string) => {
    if (!mineInfo) return false;
    return mineInfo.permission.some((p) => p.code === permission);
  };

  return (
    <MineInfoContext.Provider value={{ mineInfo, setMineInfo, checkPermission }}>{children}</MineInfoContext.Provider>
  );
};

export const useMineInfo = () => {
  const context = useContext(MineInfoContext);

  const { mineInfo } = context;

  const checkPermission = (permission: string) => {
    if (!mineInfo) return false;
    return mineInfo.permission.some((p) => p.code === permission);
  };

  if (!context) {
    throw new Error("useMineInfo must be used within a MineInfoContextProvider");
  }
  return { ...context, checkPermission };
};
